export const antdTheme = {
    token: {
      colorPrimary: '#032f58',
      colorPrimaryHover: '#032f58',
      colorLink: '#0030A5',
      fontFamily: 'Pretendard',
      fontSize: '13px',
      borderRadius : 4,
      controlHeightSM : 26,
      lineHeight : 1.7,
    },
  };
